<template>
  <div class="home">
    <!-- <div class="banner">

    </div> -->

    <div class="hj-carousel"
         @mouseenter="stop"
         @mouseleave="go">
      <!--<div class="banner-title">
        <h2 class="banner-title-world">
          <span>救援，伴</span>您畅游广阔世界</h2>
        <h4 class="banner-title-hope">【伴您通行，多一份希望】</h4>
        <div class="banner-title-icon"></div>
      </div>-->
      <transition-group name="list"
                        tag="ul"
                        ref="container">
        <li v-for="(item, index) in carouselInfo"
            :key="index"
            class="list-item"
            v-show="index === currentIndex"
            @webkitTransitionend="carouseTransition"
            :style="{backgroundImage: `url(${item.img})`}">
          <!-- 轮播图文本介绍 -->
          <!-- <div class="wrapper intro-box">
            <div class="service-intro">
              <h2>{{item.title}}</h2>
              <p>{{item.intro_one}}</p>
              <p>{{item.intro_two}}</p>
              <router-link class="intro-btn" :to="item.target_url">查看</router-link>
            </div>
          </div> -->
        </li>
      </transition-group>
      <!-- 小圆点 -->
      <ol class="circles-items">
        <li v-for="(item,index) in carouselInfo.length"
            :class="{'active':index===currentIndex}"
            :key="index"
            @click="change(index)"></li>
      </ol>
    </div>
    <div class="body-white">
      <div class="body">
        <div class="title clearfix">
          <span class="title-name name1">核心业务</span>
          <span class="title-english title-white">CORE BUSINESS</span>
          <span class="title-note title-white">核心业务范围</span>
          <div class="title-line"></div>
        </div>
        <div class="core-box">
          <router-link class="core-business"
                       target="_blank"
                       to="/internationalIndex">
            <img :src="business1"
                 alt="">
            <div class="core-btm">
              <p class="core-btm-txt">海外医疗</p>
              <p class="core-btm-en">Medical And Healthcare Tourism</p>
            </div>
          </router-link>
          <router-link class="core-business"
                       target="_blank"
                       to="/rescue">
            <img :src="business2"
                 alt="">
            <div class="core-btm">
              <p class="core-btm-txt">全球救援</p>
              <p class="core-btm-en">Emergency Assistance</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="body-gray">
      <div class="body">
        <div class="title clearfix">
          <span class="title-name name2">从服务查找</span>
          <span class="title-english title-gray">SEARCH OUR SERVICES</span>
          <span class="title-note title-gray">服务查找</span>
          <div class="title-line"></div>
        </div>
        <div class="service">
          <router-link class="service-box"
                       to="/internationalMedicine">
            <img :src="service1"
                 alt="">
            <div class="service-content">
              <h5>出国看病</h5>
              <p>Medical<br/> tourism</p>
            </div>
          </router-link>
          <router-link class="service-box"
                       to="/internationalBodyCheck">
            <img :src="service2"
                 alt="">
            <div class="service-content">
              <h5>精密体检</h5>
              <p>Medical<br/> Checkup</p>
            </div>
          </router-link>
          <router-link class="service-box"
                       to="/internationalConsultation">
            <img :src="service3"
                 alt="">
            <div class="service-content">
              <h5>远程咨询</h5>
              <p>Remote<br/> Medical care</p>
            </div>
          </router-link>
          <router-link class="service-box"
                       to="/rescueOfEmergencyInChina">
            <img :src="service4"
                 alt="">
            <div class="service-content">
              <h5>在华救援</h5>
              <p>Domestic<br/>Assistance</p>
            </div>
          </router-link>
          <router-link class="service-box"
                       to="/rescueOfOverseasService">
            <img :src="service5"
                 alt="">
            <div class="service-content">
              <h5>境外救援</h5>
              <p>Overseas<br/> Assistance</p>
            </div>
          </router-link>
          <router-link class="service-box"
                       to="/rescueOfPersonalized">
            <img :src="service6"
                 alt="">
            <div class="service-content">
              <h5>定制救援</h5>
              <p>Remote<br/>Healthcare</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="body-white">
      <div class="body">
        <div class="title clearfix">
          <span class="title-name name7">威马捷服务</span>
          <span class="title-english title-white">OUR SERVICES</span>
          <span class="title-note title-white">威马捷服务</span>
          <div class="title-line"></div>
        </div>
        <div class="">
          <img :src="ourService"
               alt="威马捷服务"
               style="width:970px;height: 366px;">
        </div>
        <div class="title clearfix">
          <span class="title-name name3">最新动态</span>
          <span class="title-english title-white">NEWS</span>
          <span class="title-note title-white">最新动态</span>
          <div class="title-line"></div>
        </div>
        <router-link class="news-list"
                     target="_blank"
                     :to="{name: 'CorporateKnowledgeDetail',params:{ id: news.id} }"
                     v-for="(news,index) in newsList">
          <div class="news-date">{{news.created_at | formatDate}}</div>
          <div class="news-state" :style="{ background: news.color }">{{ news.tag_name }}</div>
          <div class="news-info">
            <h4>{{news.title}}</h4>
            <p>{{news.news_describe}}</p>
          </div>
        </router-link>
        <router-link class="news-more"
                     to="/corporateKnowledge">
          <span>查看更多</span>
        </router-link>
      </div>
    </div>
    <div class="body-gray">
      <div class="body">
        <div class="title clearfix">
          <span class="title-name name1">友情链接</span>
          <span class="title-english title-gray">LINKS</span>
          <span class="title-note title-gray">友情链接</span>
          <div class="title-line"></div>
        </div>
        <div class="link-content">
          <a class="link-cell cell1"
             target="_blank"
             href="https://www.cn.emb-japan.go.jp">
            <div class="link-text link1">日本国驻华大使馆</div>
            <div class="link-text-shadow"></div>
          </a>
          <a class="link-cell cell2"
             target="_blank"
             href="https://emergency.co.jp/">
            <!-- 日本威马捷救援株式会社-->
            <div class="link-text link2">Emergency Assistance Japan Co.Ltd.</div>
            <div class="link-text-shadow"></div>
          </a>
          <a class="link-cell cell3"
             target="_blank"
             href="http://www.gwcslife.com/">
            <div class="link-text link3">长生人寿保险有限公司</div>
            <div class="link-text-shadow"></div>
          </a>
          <a class="link-cell cell3"
             target="_blank"
             href="https://maj.emergency.co.jp/zh/">
            <div class="link-text link4"><span style="font-size: 18px;">EAJ医疗旅游服务</span></div>
            <div class="link-text-shadow"></div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { mapState } from "vuex";
import business1 from "@/assets/images/home/img-business1.png";
import business2 from "@/assets/images/home/img-business2.png";
import service1 from "@/assets/images/home/icon-service1.png";
import service2 from "@/assets/images/home/icon-service2.png";
import service3 from "@/assets/images/home/icon-service3.png";
import service4 from "@/assets/images/home/icon-service4.png";
import service5 from "@/assets/images/home/icon-service5.png";
import service6 from "@/assets/images/home/icon-service6.png";
import ourService from "@/assets/images/home/our_service.png";

import banner1 from "@//assets/images/home/banner-1.png"
import banner2 from "@//assets/images/home/banner-2.png"
import banner3 from "@//assets/images/home/banner-3.jpg"



import * as others from "@/api/other.js"
export default {
  name: 'home',
  data () {
    return {
      business1,
      business2,
      service1,
      service2,
      service3,
      service4,
      service5,
      service6,
      ourService,
      carouselInfo: [
        { img: banner1 },
        { img: banner2 },
        { img: banner3 }
      ],
      // 当前索引
      currentIndex: 0,
      // 定时器
      timer: '',
      // 小圆点开关
      begin: '',
      newsList: [], //最新动态
    }
  },
  filters: {
    formatDate: function (val) {
      let res = val.substr(0, 10);
      return res;
    }
  },
  components: {
    // HelloWorld
    // SideBar
  },
  mounted: function () {
    this.$nextTick(() => {
      if (this.begin) {
        return;
      }
      this.begin = true;
      this.timer = setInterval(() => {
        this.autoPlay()
      }, 3000)
    });
    this.getNewsList(1);
    let token = localStorage.getItem('token')
    if (token) {
      this.$store.commit('MAIL', !this.mail);
    }
  },
  computed: {
    ...mapState({
      mail: state => state.mail,
    })
  },
  methods: {
    go () {
      this.timer = setInterval(() => {
        this.autoPlay()
      }, 3000)
    },
    stop () {
      clearInterval(this.timer);
      this.timer = null
    },
    change (index) {
      this.currentIndex = index
    },
    autoPlay () {
      this.currentIndex++;
      if (this.currentIndex > this.carouselInfo.length - 1) {
        this.currentIndex = 0
      }
    },
    carouseTransition () {
      this.begin = false;
    },
    async getNewsList (page) {
      try {
        let data = {
          page: page
        };
        let res = await others.getCorperateKnowledge(data);
        if (res.code == 200) {
          res.data.data.forEach((item, index) => {
            if (index < 3) {
              this.newsList.push(item);
            }
          })
          // this.total = res.data.total;
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style lang="less" scoped>
// .home{
//   background: #fff;
// }
img {
  backface-visibility:hidden;
  -webkit-backface-visibility:hidden;
}
.banner {
  width: 100%;
  height: 350px;
  /*background: url('../assets/images/home/banner1.png') no-repeat center;*/
}

.banner-title {
  position: absolute;
  left: 50%;
  top: 0;
  z-index: 9;
  width: 564px;
  height: 350px;
  margin-left: -533px;
  background: rgba(255, 255, 255, 0.78);
  padding-left: 48px;
  padding-top: 110px;
  .banner-title-world {
    font-size: 42px;
    color: #333130;
    line-height: 46px;
    margin-bottom: 20px;
    span {
      color: #ae1e10;
    }
  }
  .banner-title-hope {
    font-size: 30px;
    color: #333130;
    line-height: 40px;
    font-weight: normal;
    margin-bottom: 24px;
  }
  .banner-title-icon {
    width: 58px;
    height: 4px;
    background: #333130;
  }
}
//banner 轮播
.hj-carousel {
  position: relative;
  width: 100%;
  height: 345px;
  .list-item {
    position: absolute;
    width: 1440px;
    height: 345px;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    background-position: center center;
    background-size: 100% auto;
    .intro-box {
      position: relative;
      height: 100%;
      .service-intro {
        width: 418px;
        position: absolute;
        top: 152px;
        left: 58px;
        color: #fff;
        h2 {
          height: 53px;
          line-height: 53px;
          font-size: 38px;
          font-weight: 500;
        }
        p {
          height: 34px;
          line-height: 34px;
          font-size: 18px;
        }
        .intro-btn {
          display: block;
          margin-top: 33px;
          width: 123px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background: linear-gradient(
            360deg,
            rgba(228, 39, 53, 1) 0%,
            rgba(235, 121, 101, 1) 100%
          );
          box-shadow: 0 5px 20px 0 rgba(230, 2, 19, 0.5);
          border-radius: 5px;
          color: #fff;
          text-decoration: none;
        }
      }
    }
  }
  .circles-items {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 16px;
    z-index: 10;
    margin: 0 auto;
    text-align: center;
    font-size: 0;
    overflow: hidden;
    li {
      width: 100px;
      height: 3px;
      float: left;
      margin-right: 30px;
      // border-radius: 50%;
      background-color: rgba(51, 49, 48, 0.28);
      cursor: pointer;
      &.active {
        background-color: #cf1300;
      }
    }
  }
}

.list-enter,
.list-leave-to {
  width: 0;
  height: 0;
  opacity: 0;
}

.list-leave-active,
.list-enter-active {
  transition: all 1s linear;
}
//banner 轮播
.body-white {
  background: #fff;
}
.body-gray {
  background: #f6f6f6;
}
.body {
  width: 970px;
  overflow: hidden;
  margin: 0 auto;
}

.core-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 94px;
}
.core-business {
  position: relative;
  display: block;
  width: 470px;
  height: 313px;
  overflow: hidden;
  img {
    width: 470px;
    // height: 522px;
    transform-origin: center;
    transition: 0.5s linear;
  }
}
.core-business:hover img {
  transform: scale(1.5);
}
.core-btm {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 80px;
  background: rgba(39, 39, 39, 0.69);
  text-align: center;
  padding: 15px 0;
  transition: 0.3s ease;
}
.core-business:hover .core-btm {
  // transform: translateY(-122px);
  transition: 0.3s ease;
}
.core-btm-txt {
  font-size: 24px;
  color: #fff;
  line-height: 30px;
  margin-bottom: 2px;
}
.core-btm-en {
  color: #adaeae;
  font-size: 16px;
  line-height: 20px;
}
.service {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  .service-box {
    width: 318px;
    margin-bottom: 55px;
    img {
      width: 64px;
      height: 64px;
      vertical-align: top;
      margin-right: 14px;
    }
    .service-content {
      display: inline-block;
      width: 240px;
      h5 {
        font-size: 24px;
        color: #141414;
        line-height: 30px;
        margin-bottom: 10px;
      }
      p {
        position: relative;
        font-size: 18px;
        color: #adaeae;
        line-height: 22px;
        white-space: normal;
        text-transform: uppercase;
        padding-bottom: 8px;
      }
      p::after {
        position: absolute;
        left: 0;
        bottom: 2px;
        content: '';
        display: inline-block;
        width: 40px;
        height: 2px;
        background: #adaeae;
      }
    }
  }
}
.news-list {
  display: block;
  border-bottom: 1px solid #d8d8d8;
  padding: 48px 0 40px;
  transition: 0.5s linear;
  .news-date {
    display: inline-block;
    font-size: 20px;
    color: #333130;
    line-height: 24px;
    vertical-align: top;
    margin-right: 60px;
    transition: 0.3s linear;
  }
  .news-state {
    display: inline-block;
    background: #ae1e10;
    font-size: 14px;
    color: #fff;
    line-height: 26px;
    vertical-align: top;
    padding: 0 14px;
    margin-right: 20px;
    transition: 0.3s linear;
    width: 88px;
    text-align: center;
  }
  .news-info {
    display: inline-block;
    width: 666px;
    vertical-align: top;
    h4 {
      font-size: 20px;
      color: #333130;
      line-height: 28px;
      margin-bottom: 18px;
    }
    p {
      font-size: 16px;
      color: #898888;
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.news-list:hover .news-date {
  transform: scale(1.2) translateX(12px);
  transition: 0.3s linear;
}
.news-list:hover .news-state {
  transform: scale(1.2);
  transition: 0.3s linear;
}
.news-list:hover .news-info h4 {
  transform: scale(1.1) translateX(30px);
  transition: 0.3s linear;
}
// .news-list:hover .news-info p {
//   transform: scale(1.1);
//   transition: 0.3s linear;
// }
.link-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 80px;
  .link-cell {
    position: relative;
    width: 450px;
    height: 110px;
    background: #fff;
    border: 1px solid #d6d6d6;
    margin-bottom: 34px;
    // transition: 0.5s linear;
    .link-text {
      position: absolute;
      right: 0;
      top: 20px;
      z-index: 3;
      width: 338px;
      height: 50px;
      font-size: 22px;
      color: #fff;
      line-height: 50px;
      text-align: center;
      transition: 0.3s linear;
    }
    .link-text-shadow {
      position: absolute;
      right: 0;
      top: 32px;
      z-index: 1;
      display: block;
      width: 352px;
      height: 50px;
      background: #d8d8d8;
    }
    .link1 {
      background: #ae1e10;
    }
    .link2 {
      background: #3c4c7e;
    }
    .link3 {
      background: #585858;
    }
    .link4 {
      background: #7c6f41;
    }
  }
  .link-cell:hover .link-text {
    width: 352px;
    transform: translateY(14px);
    transform-origin: right bottom;
    transition: 0.3s linear;
  }
  .cell1 {
    background: #fff url('../assets/images/home/icon-link1.png') no-repeat 20px
      22px;
  }
  .cell2 {
    background: #fff url('../assets/images/home/icon-link2.png') no-repeat 20px
      22px;
  }
  .cell3 {
    background: #fff url('../assets/images/home/icon-link3.png') no-repeat 20px
      22px;
  }
}
</style>
<style lang="less">
.title {
  position: relative;
  margin: 50px 0;
}
.title-name {
  float: left;
  font-size: 26px;
  color: #333130;
  line-height: 30px;
  padding-left: 40px;
}
.name1 {
  background: url('../assets/images/home/icon1.png') no-repeat left center;
}
.name2 {
  background: url('../assets/images/home/icon2.png') no-repeat left center;
  background-size: 30px auto;
}
.name3 {
  background: url('../assets/images/home/icon3.png') no-repeat left center;
}
.name4 {
  background: url('../assets/images/home/icon4.png') no-repeat left center;
}
.name5 {
  background: url('../assets/images/home/icon5.png') no-repeat left center;
}
.name6 {
  background: url('../assets/images/home/icon6.png') no-repeat left center;
}
.name7 {
  background: url('../assets/images/home/icon7.png') no-repeat left center;
  background-size: 32px auto;
}
.title-line {
  width: auto;
  height: 1px;
  background-color: #d8d8d8;
  margin-left: 150px;
  margin-top: -2px;
}
.title-english {
  position: relative;
  display: inline-block;
  font-size: 16px;
  color: #898888;
  line-height: 20px;
  padding: 0 26px;
  margin-top: 10px;
  margin-left: 30px;
}
.title-white {
  background: #fff;
}
.title-gray {
  background: #f6f6f6;
}
.title-english::before {
  position: absolute;
  left: 4px;
  bottom: 0;
  display: inline-block;
  content: '';
  width: 1px;
  height: 16px;
  background: #8a8988;
  transform: rotateZ(45deg);
}
.title-english::after {
  position: absolute;
  right: 4px;
  bottom: 0;
  display: inline-block;
  content: '';
  width: 1px;
  height: 16px;
  background: #8a8988;
  transform: rotateZ(45deg);
}
.title-note {
  position: absolute;
  right: 0;
  bottom: 0;
  display: inline-block;
  font-size: 14px;
  color: #b2b3b3;
  line-height: 20px;
  padding-left: 6px;
  padding-right: 16px;
}
.title-note::after {
  position: absolute;
  right: 0;
  bottom: 2px;
  display: inline-block;
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #d9d9d9;
}
.news-more {
  display: block;
  width: 270px;
  height: 50px;
  border: 1px solid #d8d8d8;
  background: url('../assets/images/home/icon-pointer.png') no-repeat 177px 20px;
  padding: 12px 0 12px 60px;
  margin: 52px auto 72px;
  span {
    display: inline-block;
    color: #333130;
    font-size: 14px;
    line-height: 26px;
    border-right: 1px solid #d8d8d8;
    padding-right: 38px;
  }
}
</style>
